import ConfirmationDeleteWithList from './ConfirmationDeleteWithList';

export default ConfirmationDeleteWithList;
